import { createContext } from 'react';

import type { SidebarToggleMeta } from './useSidebarState';

type SidebarContextType = {
  isVisible: boolean;
  isRail?: boolean;
  isForcedExpanded?: boolean;
  toggle(meta?: SidebarToggleMeta): void;
  consumeFocusHandoff?: () => boolean;
};

export const SidebarContext = createContext<SidebarContextType | undefined>(undefined);
